/* ==========================================================================
   ML · Questionnaire (pop-up), BigStudio. Global, progressive, fault tolerant.
   Triggers: click on [href="#quiz"] or [data-ml-quiz], or URL ?quiz=1.
   Flow: intro -> questions (one per step) -> email -> submit -> thank you.
   Submit: POST to the VPS (stores answers) + Shopify native form (tags the customer).
   ========================================================================== */
(function () {
  'use strict';

  var root = document.getElementById('mlq');
  if (!root) return;

  /* The snippet is rendered inside the header loader, and that section is
     HIDDEN (display:none). Inside a hidden ancestor the modal exists in the DOM
     but measures 0x0 and is never seen: opening it blocked the scroll showing nothing.
     We move it to <body> ("portal" pattern) so it does not depend on any ancestor. */
  if (root.parentNode !== document.body) document.body.appendChild(root);

  var ENDPOINT = (root.getAttribute('data-endpoint') || '').replace(/\/+$/, '');
  var DEFAULT_SLUG = root.getAttribute('data-form') || 'diagnostico';
  var slugActual = DEFAULT_SLUG;   // which questionnaire is open
  var schemas = {};                // cache of questionnaires already loaded, by identifier
  var dialog = root.querySelector('.mlq__dialog');
  var body = document.getElementById('mlq-body');
  var bar = document.getElementById('mlq-bar');
  var shopForm = document.getElementById('mlq-shopify-form');

  var schema = null;      // questionnaire data (loaded from the VPS)
  var answers = {};       // { question_id: value }
  var step = 0;           // 0 = intro; 1..N = questions; N+1 = email
  var lastFocus = null;
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  var LOAD_TIMEOUT = 12000;
  var SEND_TIMEOUT = 15000;

  /* ---------- helpers ---------- */
  function esc(s) { var d = document.createElement('div'); d.textContent = s == null ? '' : String(s); return d.innerHTML; }
  function el(html) { var t = document.createElement('template'); t.innerHTML = html.trim(); return t.content.firstElementChild; }
  function questions() { return (schema && schema.questions) || []; }

  /* Safe radio/checkbox group name: the question id comes from the server, so we
     never drop it raw into an attribute or a CSS selector. */
  function groupName(q) { return 'q' + String(q.id == null ? '' : q.id).replace(/[^A-Za-z0-9_-]/g, ''); }

  /* fetch with a time limit: if the VPS never answers, the pop-up must not
     stay spinning forever. It always settles, so the UI can recover. */
  function fetchLimited(url, opts, ms) {
    if (!window.fetch) return Promise.reject(new Error('no-fetch'));
    var options = opts || {};
    var ctrl = null;
    if (window.AbortController) {
      try { ctrl = new AbortController(); options.signal = ctrl.signal; } catch (e) { ctrl = null; }
    }
    return new Promise(function (resolve, reject) {
      var settled = false;
      var timer = setTimeout(function () {
        if (settled) return;
        settled = true;
        if (ctrl) { try { ctrl.abort(); } catch (e) {} }
        reject(new Error('timeout'));
      }, ms || LOAD_TIMEOUT);
      fetch(url, options).then(function (r) {
        if (settled) return; settled = true; clearTimeout(timer); resolve(r);
      }, function (e) {
        if (settled) return; settled = true; clearTimeout(timer); reject(e);
      });
    });
  }

  /* ---------- loading the questionnaire ---------- */
  function loadSchema(slug) {
    if (schemas[slug]) return Promise.resolve(schemas[slug]);
    return fetchLimited(ENDPOINT + '/schema.php?form=' + encodeURIComponent(slug), { credentials: 'omit' }, LOAD_TIMEOUT)
      .then(function (r) { return r.ok ? r.json() : Promise.reject(new Error('http-' + r.status)); })
      .then(function (d) {
        // A reply with no questions is as broken as no reply. We never invent questions.
        if (!d || !Array.isArray(d.questions) || !d.questions.length) return Promise.reject(new Error('empty-schema'));
        schemas[slug] = d; return d;
      });
  }

  function startLoad() {
    renderLoading();
    var wanted = slugActual;
    loadSchema(wanted).then(function (d) {
      if (root.hidden || wanted !== slugActual) return;
      schema = d; step = 0; render();
    }, function () {
      if (!root.hidden) renderError();
    });
  }

  /* Identifier of the questionnaire to open, based on the trigger:
     data-ml-quiz="colegios"  ·  href="#quiz-colegios"  ·  href="#quiz" (the default one) */
  function slugDelDisparador(t) {
    var d = t.getAttribute('data-ml-quiz');
    if (d) return d;
    var href = t.getAttribute('href') || '';
    var i = href.indexOf('#quiz');
    if (i === -1) return DEFAULT_SLUG;
    var resto = href.slice(i + 5); // '' or '-colegios'
    return resto.charAt(0) === '-' ? resto.slice(1) : DEFAULT_SLUG;
  }

  /* ---------- open / close ---------- */
  function open(slug) {
    slugActual = slug || DEFAULT_SLUG;
    schema = schemas[slugActual] || null;
    lastFocus = document.activeElement;
    root.hidden = false;
    document.documentElement.style.overflow = 'hidden';
    // force reflow for the transition
    void root.offsetWidth;
    root.classList.add('is-open');
    // Safety net: if for any reason the modal was not shown (0x0) we do NOT leave
    // the page blocked. Better a button that does nothing than a frozen store.
    if (!root.offsetWidth || !root.offsetHeight) {
      document.documentElement.style.overflow = '';
      root.classList.remove('is-open');
      root.hidden = true;
      return;
    }
    step = 0; answers = {};
    document.addEventListener('keydown', onKey);
    if (!schema) startLoad(); else render();
  }
  function close() {
    root.classList.remove('is-open');
    document.removeEventListener('keydown', onKey);
    document.documentElement.style.overflow = '';
    var done = function () { root.hidden = true; body.innerHTML = ''; };
    if (reduce) done(); else setTimeout(done, 300);
    if (lastFocus && lastFocus.focus) lastFocus.focus();
  }
  function onKey(e) {
    if (e.key === 'Escape') { close(); return; }
    if (e.key === 'Tab') trapFocus(e);
  }
  function trapFocus(e) {
    var f = dialog.querySelectorAll('button, [href], input, textarea, select, [tabindex]:not([tabindex="-1"])');
    f = Array.prototype.filter.call(f, function (n) { return !n.disabled && n.offsetParent !== null; });
    if (!f.length) return;
    var first = f[0], last = f[f.length - 1];
    if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
    else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
  }
  function focusFirst() {
    var n = dialog.querySelector('.mlq__input, .mlq__textarea, .mlq__opt, .mlq__scale button, .mlq__btn--primary');
    if (n) n.focus();
  }

  /* ---------- progress ---------- */
  function setBar() {
    var total = questions().length + 1; // questions + email
    var pct = step === 0 ? 0 : Math.min(100, Math.round((step / total) * 100));
    bar.style.width = pct + '%';
  }

  /* ---------- screen rendering ---------- */
  function renderLoading() {
    bar.style.width = '0%';
    body.innerHTML = '<div class="mlq__spinner" role="status" aria-label="Loading"></div>';
  }

  function renderError() {
    bar.style.width = '0%';
    body.innerHTML =
      '<h2 class="mlq__title" id="mlq-title">Something went wrong</h2>' +
      '<p class="mlq__intro">We could not load the questionnaire right now. Please check your connection and try again.</p>' +
      '<div class="mlq__nav">' +
      '<button class="mlq__btn mlq__btn--primary" type="button" id="mlq-retry">Try again</button>' +
      '<span class="mlq__spacer"></span>' +
      '<button class="mlq__btn mlq__btn--ghost" type="button" data-mlq-close>Close</button></div>';
    var r = body.querySelector('#mlq-retry');
    if (r) r.addEventListener('click', function () { delete schemas[slugActual]; schema = null; startLoad(); });
    focusFirst();
  }

  function render() {
    // With no valid questionnaire there is nothing to show: never a blank window.
    if (!questions().length) return renderError();
    setBar();
    if (step === 0) return renderIntro();
    if (step <= questions().length) return renderQuestion(step - 1);
    return renderEmail();
  }

  function renderIntro() {
    body.innerHTML =
      '<p class="mlq__eyebrow">Langford Method</p>' +
      '<h2 class="mlq__title" id="mlq-title">' + esc(schema.title) + '</h2>' +
      (schema.intro ? '<p class="mlq__intro">' + esc(schema.intro) + '</p>' : '') +
      '<div class="mlq__nav"><button class="mlq__btn mlq__btn--primary" type="button" id="mlq-start">Start</button>' +
      '<span class="mlq__spacer"></span></div>';
    body.querySelector('#mlq-start').addEventListener('click', function () { step = 1; render(); });
    focusFirst();
  }

  function renderQuestion(idx) {
    var q = questions()[idx];
    var name = groupName(q);
    var html =
      '<p class="mlq__count">Question ' + step + ' of ' + questions().length + '</p>' +
      '<h2 class="mlq__q" id="mlq-title">' + esc(q.label) + (q.required ? '' : ' <span style="color:#97a0aa;font-weight:400">(optional)</span>') + '</h2>' +
      (q.help ? '<p class="mlq__help">' + esc(q.help) + '</p>' : '');

    if (q.type === 'single' || q.type === 'multi') {
      html += '<div class="mlq__opts">';
      (q.options || []).forEach(function (opt, i) {
        var sel = isSelected(q, opt);
        html += '<label class="mlq__opt mlq__opt--' + (q.type === 'multi' ? 'multi' : 'single') + (sel ? ' is-sel' : '') + '">' +
          '<span class="mlq__mark"><svg viewBox="0 0 24 24"><path d="M20 6 9 17l-5-5"/></svg></span>' +
          '<input type="' + (q.type === 'multi' ? 'checkbox' : 'radio') + '" name="' + name + '" value="' + esc(opt) + '"' + (sel ? ' checked' : '') + '>' +
          '<span>' + esc(opt) + '</span></label>';
      });
      html += '</div>';
    } else if (q.type === 'scale') {
      html += '<div class="mlq__scale">';
      for (var n = 1; n <= 5; n++) html += '<button type="button" data-v="' + n + '"' + (String(answers[q.id]) === String(n) ? ' class="is-sel"' : '') + '>' + n + '</button>';
      html += '</div>';
    } else if (q.type === 'textarea') {
      html += '<textarea class="mlq__textarea" id="mlq-in">' + esc(answers[q.id] || '') + '</textarea>';
    } else {
      html += '<input type="text" class="mlq__input" id="mlq-in" value="' + esc(answers[q.id] || '') + '">';
    }

    html += '<p class="mlq__err" id="mlq-err" role="alert"></p>' +
      '<div class="mlq__nav">' +
      '<button class="mlq__btn mlq__btn--ghost" type="button" id="mlq-back">Back</button>' +
      '<span class="mlq__spacer"></span>' +
      '<button class="mlq__btn mlq__btn--primary" type="button" id="mlq-next">Next</button></div>';

    body.innerHTML = html;
    wireQuestion(q);
    body.querySelector('#mlq-back').addEventListener('click', function () { step--; render(); });
    body.querySelector('#mlq-next').addEventListener('click', function () { if (commitQuestion(q)) { step++; render(); } });
    focusFirst();
  }

  function isSelected(q, opt) {
    var v = answers[q.id];
    if (q.type === 'multi') return Array.isArray(v) && v.indexOf(opt) !== -1;
    return v === opt;
  }

  function wireQuestion(q) {
    if (q.type === 'single' || q.type === 'multi') {
      body.querySelectorAll('.mlq__opt').forEach(function (lab) {
        var input = lab.querySelector('input');
        input.addEventListener('change', function () {
          if (q.type === 'single') {
            body.querySelectorAll('.mlq__opt').forEach(function (l) { l.classList.remove('is-sel'); });
            lab.classList.add('is-sel');
          } else {
            lab.classList.toggle('is-sel', input.checked);
          }
        });
      });
    } else if (q.type === 'scale') {
      body.querySelectorAll('.mlq__scale button').forEach(function (b) {
        b.addEventListener('click', function () {
          body.querySelectorAll('.mlq__scale button').forEach(function (x) { x.classList.remove('is-sel'); });
          b.classList.add('is-sel'); answers[q.id] = b.getAttribute('data-v');
        });
      });
    }
  }

  function commitQuestion(q) {
    var err = body.querySelector('#mlq-err');
    var name = groupName(q);
    if (q.type === 'single') {
      var r = body.querySelector('input[name="' + name + '"]:checked');
      answers[q.id] = r ? r.value : undefined;
    } else if (q.type === 'multi') {
      var arr = [];
      body.querySelectorAll('input[name="' + name + '"]:checked').forEach(function (c) { arr.push(c.value); });
      answers[q.id] = arr.length ? arr : undefined;
    } else if (q.type === 'scale') {
      // already stored in answers[q.id] on click
    } else {
      var inp = body.querySelector('#mlq-in');
      answers[q.id] = inp.value.trim() || undefined;
    }
    if (q.required && (answers[q.id] === undefined || (Array.isArray(answers[q.id]) && !answers[q.id].length))) {
      if (err) err.textContent = 'Please answer this question to continue.';
      return false;
    }
    return true;
  }

  function renderEmail() {
    body.innerHTML =
      '<p class="mlq__count">Last step</p>' +
      '<h2 class="mlq__q" id="mlq-title">Where should we send your result?</h2>' +
      '<p class="mlq__help">You will receive a personalized recommendation.</p>' +
      '<div class="mlq__field"><label class="mlq__label" for="mlq-email">Email address</label>' +
      '<input type="email" id="mlq-email" class="mlq__input" autocomplete="email" placeholder="you@example.com" value="' + esc(answers._email || '') + '"></div>' +
      '<div class="mlq__field"><label class="mlq__label" for="mlq-name">Name (optional)</label>' +
      '<input type="text" id="mlq-name" class="mlq__input" autocomplete="name" value="' + esc(answers._name || '') + '"></div>' +
      '<div class="mlq__hp"><label>Do not fill this in<input type="text" id="mlq-company" tabindex="-1" autocomplete="off"></label></div>' +
      '<p class="mlq__err" id="mlq-err" role="alert"></p>' +
      '<div class="mlq__nav">' +
      '<button class="mlq__btn mlq__btn--ghost" type="button" id="mlq-back">Back</button>' +
      '<span class="mlq__spacer"></span>' +
      '<button class="mlq__btn mlq__btn--primary" type="button" id="mlq-send">Send</button></div>' +
      '<p class="mlq__consent">By sending this, you agree that Langford Method may use your email to send you your result and updates. You can unsubscribe at any time.</p>';
    body.querySelector('#mlq-back').addEventListener('click', function () { step--; render(); });
    body.querySelector('#mlq-send').addEventListener('click', submit);
    focusFirst();
  }

  var EMAIL_RE = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

  function submit() {
    var err = body.querySelector('#mlq-err');
    var email = (body.querySelector('#mlq-email').value || '').trim();
    var name = (body.querySelector('#mlq-name').value || '').trim();
    var honey = (body.querySelector('#mlq-company').value || '').trim();
    if (!EMAIL_RE.test(email)) { if (err) err.textContent = 'Please enter a valid email address.'; return; }
    answers._email = email; answers._name = name;

    var btn = body.querySelector('#mlq-send');
    btn.disabled = true; btn.textContent = 'Sending...';

    // Answers payload for the VPS
    var payload = { form: slugActual, email: email, name: name, company: honey, answers: {} };
    questions().forEach(function (q) { if (answers[q.id] !== undefined) payload.answers[q.id] = answers[q.id]; });

    var savedOk = false, taggedOk = false;

    // 1) Store the answers on the VPS
    var saveVps = fetchLimited(ENDPOINT + '/submit.php', {
      method: 'POST', credentials: 'omit',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(payload)
    }, SEND_TIMEOUT)
      .then(function (r) {
        if (!r.ok) return Promise.reject(new Error('http-' + r.status));
        return r.json().catch(function () { return null; });
      })
      .then(function (d) { savedOk = !(d && d.ok === false); }, function () { savedOk = false; });

    // 2) Create/tag the customer in Shopify (native form, no token)
    var tagShopify = Promise.resolve();
    if (shopForm) {
      try {
        var fd = new FormData(shopForm);
        fd.set('contact[email]', email);
        if (schema && schema.shopify_tag) fd.set('contact[tags]', schema.shopify_tag);
        tagShopify = fetchLimited(shopForm.getAttribute('action') || '/contact', {
          method: 'POST', body: fd, headers: { 'Accept': 'text/html' }
        }, SEND_TIMEOUT).then(function (r) { taggedOk = !!(r && r.ok); }, function () { taggedOk = false; });
      } catch (e) {}
    }

    renderSubmitting();
    // Both branches always settle (timeout included), so the spinner can never hang.
    Promise.all([saveVps, tagShopify]).then(function () {
      if (savedOk || taggedOk) renderDone(); else renderSubmitError();
    }, function () { renderSubmitError(); });
  }

  function renderSubmitting() {
    setBar(); bar.style.width = '100%';
    body.innerHTML = '<div class="mlq__spinner" role="status" aria-label="Sending"></div>';
  }

  function renderSubmitError() {
    bar.style.width = '100%';
    body.innerHTML =
      '<h2 class="mlq__title" id="mlq-title">We could not send your answers</h2>' +
      '<p class="mlq__intro">Please check your connection and try again. Your answers are still here.</p>' +
      '<div class="mlq__nav">' +
      '<button class="mlq__btn mlq__btn--primary" type="button" id="mlq-retry">Try again</button>' +
      '<span class="mlq__spacer"></span>' +
      '<button class="mlq__btn mlq__btn--ghost" type="button" data-mlq-close>Close</button></div>';
    var r = body.querySelector('#mlq-retry');
    if (r) r.addEventListener('click', function () { step = questions().length + 1; render(); });
    focusFirst();
  }

  function renderDone() {
    bar.style.width = '100%';
    var t = (schema && schema.success_title) || 'Thank you';
    var x = (schema && schema.success_text) || 'We have received your answers.';
    var actions = '';
    if (schema && schema.success_cta_label && schema.success_cta_url) {
      actions += '<a class="mlq__btn mlq__btn--primary" style="text-decoration:none;display:inline-flex;align-items:center;justify-content:center" href="' + esc(schema.success_cta_url) + '">' + esc(schema.success_cta_label) + '</a>';
    }
    if (schema && schema.success_link_label && schema.success_link_url) {
      actions += '<a class="mlq__btn mlq__btn--ghost" style="text-decoration:none;display:inline-flex;align-items:center;justify-content:center" href="' + esc(schema.success_link_url) + '">' + esc(schema.success_link_label) + '</a>';
    }
    if (!actions) actions = '<button class="mlq__btn mlq__btn--primary" type="button" data-mlq-close>Done</button>';
    body.innerHTML =
      '<div class="mlq__done">' +
      '<div class="mlq__done-ico"><svg viewBox="0 0 24 24"><path d="M20 6 9 17l-5-5"/></svg></div>' +
      '<h2 class="mlq__title" id="mlq-title" style="color:#121212">' + esc(t) + '</h2>' +
      '<p class="mlq__intro">' + esc(x) + '</p>' +
      '<div class="mlq__nav" style="flex-direction:column;align-items:center;gap:1rem">' + actions + '</div>' +
      '</div>';
    // The final buttons must CLOSE the modal before navigating. Otherwise an anchor
    // link on the same page (e.g. /#plans from the home page) does not reload, the
    // modal stays open and the scroll lock gets stuck.
    body.querySelectorAll('.mlq__done a').forEach(function (a) {
      a.addEventListener('click', function () { close(); });
    });
    focusFirst();
  }

  /* ---------- triggers ---------- */
  root.addEventListener('click', function (e) {
    if (e.target.closest('[data-mlq-close]') || e.target.classList.contains('mlq__backdrop')) close();
  });
  document.addEventListener('click', function (e) {
    var t = e.target.closest('a[href*="#quiz"], [data-ml-quiz]');
    if (t) { e.preventDefault(); open(slugDelDisparador(t)); }
  });
  // Open from the URL: ?quiz=1 (the default one) or ?quiz=colegios
  try {
    var qp = new URLSearchParams(window.location.search).get('quiz');
    if (qp) {
      var s = (qp === '1' || qp === 'true') ? DEFAULT_SLUG : qp;
      // NOTE: wrap in a function, otherwise 'load' passes the Event as the identifier.
      if (document.readyState === 'complete') open(s);
      else window.addEventListener('load', function () { open(s); });
    }
  } catch (e) {}
})();
